import React from 'react';
import { usePostosCombustivel } from 'src/controllers/Dashboard/FleetAdmin/PostosCombustivelController';

const fmtL = (v: number) => v.toLocaleString('pt-BR') + ' L';
const fmtBRL = (v: number) => v.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' });

const PostosCombustivelCard: React.FC = () => {
    const { data, loading } = usePostosCombustivel();

    if (!loading && data.length === 0) return null;

    const maxLitros = Math.max(...data.map(p => p.litrosMes), 1);

    return (
        <div style={{
            background: '#1e1e2e',
            borderRadius: 16,
            padding: '1.2rem 1.4rem',
            marginBottom: '1.5rem',
        }}>
            <div style={{
                display: 'flex',
                justifyContent: 'space-between',
                alignItems: 'center',
                marginBottom: 14,
            }}>
                <span style={{ color: '#fff', fontWeight: 700, fontSize: 18 }}>
                    Postos Autorizados
                </span>
                <span style={{ color: '#a0aec0', fontSize: 12 }}>mês atual</span>
            </div>

            {loading ? (
                <div style={{ textAlign: 'center', padding: '1rem' }}>
                    <i className="pi pi-spin pi-spinner" style={{ fontSize: '1.5em', color: '#fff' }} />
                </div>
            ) : (
                data.map((posto, i) => {
                    const pct = Math.round((posto.litrosMes / maxLitros) * 100);
                    return (
                        <div key={i} style={{
                            background: '#2a2a3e',
                            borderRadius: 12,
                            padding: '0.85rem 1rem',
                            marginBottom: 10,
                        }}>
                            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start' }}>
                                <div style={{ display: 'flex', gap: 10, alignItems: 'center' }}>
                                    <span style={{
                                        width: 10,
                                        height: 10,
                                        borderRadius: '50%',
                                        background: '#22c55e',
                                        display: 'inline-block',
                                        flexShrink: 0,
                                        marginTop: 3,
                                    }} />
                                    <div>
                                        <div style={{ color: '#fff', fontWeight: 600, fontSize: 15 }}>
                                            {posto.estabelecimento}
                                        </div>
                                        <div style={{ color: '#a0aec0', fontSize: 12, marginTop: 2 }}>
                                            {posto.totalAbast} abastecimentos · {fmtBRL(posto.valorMes)}
                                        </div>
                                    </div>
                                </div>
                                <div style={{ textAlign: 'right', flexShrink: 0 }}>
                                    <div style={{ color: '#fff', fontWeight: 700, fontSize: 16 }}>
                                        {fmtL(posto.litrosMes)}
                                    </div>
                                    <div style={{ color: '#a0aec0', fontSize: 11 }}>mês atual</div>
                                </div>
                            </div>
                            {/* barra de progresso */}
                            <div style={{
                                marginTop: 8,
                                height: 4,
                                background: '#3a3a50',
                                borderRadius: 4,
                                overflow: 'hidden',
                            }}>
                                <div style={{
                                    height: '100%',
                                    width: `${pct}%`,
                                    background: '#3b82f6',
                                    borderRadius: 4,
                                    transition: 'width 0.4s ease',
                                }} />
                            </div>
                        </div>
                    );
                })
            )}
        </div>
    );
};

export default PostosCombustivelCard;
